import React from "react";
import "./Styles/footerStyles.css";

const Footer = () => {
  return <p className="footer">Copyright © {new Date().getFullYear()} Williams Lea. All Rights Reserved.</p>;
};

export default Footer;
